export default "__VITE_ASSET__Cng40ClU__"